import {
  Activity,
  ArrowLeftRight,
  AudioWaveform,
  Blend,
  Calculator,
  Camera,
  Circle,
  CircleDashed,
  Clock3,
  Cpu,
  Crosshair,
  Dices,
  Focus,
  Ghost,
  Grid3X3,
  Hash,
  Layers2,
  Mic2,
  MonitorUp,
  MessageSquare,
  Move,
  MousePointer2,
  Palette,
  RotateCw,
  ScanLine,
  Shuffle,
  Sparkles,
  Timer,
  Waves,
  Zap,
  type LucideIcon,
} from 'lucide-react';
import type { NodeKind, OperatorDomain } from '../graph';

interface OperatorMeta {
  accent: string;
  icon: LucideIcon;
  shortLabel: string;
}

export const DOMAIN_LABELS: Record<OperatorDomain, string> = {
  control: 'Signals',
  frame: 'Visuals',
  display: 'Outputs',
};
export const DOMAIN_ACCENTS: Record<OperatorDomain, string> = {
  control: '#d8ff5f',
  frame: '#65ddff',
  display: '#ff795c',
};

export const OPERATOR_META: Record<NodeKind, OperatorMeta> = {
  time: { accent: '#d8ff5f', icon: Clock3, shortLabel: 'Time' },
  beatClock: { accent: '#a6ff83', icon: Timer, shortLabel: 'Beat' },
  autoSelector: { accent: '#c3f06b', icon: Dices, shortLabel: 'Auto' },
  oscillator: { accent: '#b8ef66', icon: AudioWaveform, shortLabel: 'LFO' },
  constant: { accent: '#d8ff5f', icon: Hash, shortLabel: 'Value' },
  math: { accent: '#c8f46c', icon: Calculator, shortLabel: 'Math' },
  mapRange: { accent: '#b5ed79', icon: ArrowLeftRight, shortLabel: 'Map' },
  smooth: { accent: '#a6e986', icon: Activity, shortLabel: 'Smooth' },
  pointer: { accent: '#f2d65f', icon: MousePointer2, shortLabel: 'Pointer' },
  aiPrompt: { accent: '#ffcf6a', icon: MessageSquare, shortLabel: 'Chat' },
  xyPad: { accent: '#d8ff5f', icon: Crosshair, shortLabel: 'XY Pad' },
  audioLevel: { accent: '#ffbd5f', icon: Mic2, shortLabel: 'Audio' },
  videoInput: { accent: '#5fffc7', icon: Camera, shortLabel: 'Camera' },
  videoModel: { accent: '#70e4ff', icon: Cpu, shortLabel: 'Model' },
  solid: { accent: '#5fe6ff', icon: Circle, shortLabel: 'Solid' },
  plasma: { accent: '#65ddff', icon: Sparkles, shortLabel: 'Field' },
  cells: { accent: '#70aaff', icon: Grid3X3, shortLabel: 'Cells' },
  warp: { accent: '#8d9cff', icon: Waves, shortLabel: 'Warp' },
  blend: { accent: '#a88cff', icon: Blend, shortLabel: 'Blend' },
  threshold: { accent: '#76baff', icon: ScanLine, shortLabel: 'Threshold' },
  mask: { accent: '#908fff', icon: CircleDashed, shortLabel: 'Mask' },
  composite: { accent: '#b783ff', icon: Layers2, shortLabel: 'Composite' },
  frameSwitch: { accent: '#c77eff', icon: Shuffle, shortLabel: 'Switch' },
  blur: { accent: '#d481ff', icon: Focus, shortLabel: 'Blur' },
  trails: { accent: '#df83ff', icon: Ghost, shortLabel: 'Trails' },
  feedbackSpiral: { accent: '#f06dff', icon: RotateCw, shortLabel: 'Spiral' },
  strobe: { accent: '#ff72d5', icon: Zap, shortLabel: 'Strobe' },
  colorGrade: { accent: '#ff80bb', icon: Palette, shortLabel: 'Grade' },
  transform2d: { accent: '#7dcfff', icon: Move, shortLabel: 'Transform' },
  display: { accent: '#ff795c', icon: MonitorUp, shortLabel: 'Display' },
};
